import { resolveInstanceUrl } from '../config/instances';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Expected shape: /<instance_uuid>/<stream_uuid>?stream_id_type=internal|external
export function parsePlayerRoute(pathname, search) {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length !== 2 || !UUID_RE.test(segments[0]) || !UUID_RE.test(segments[1])) {
    return {
      error: {
        title: 'Invalid player link',
        message: 'This player link is malformed. Expected a URL in the form /<instance>/<stream>.',
      },
    };
  }

  const [instanceUuid, streamUuid] = segments;
  const instanceUrl = resolveInstanceUrl(instanceUuid);

  if (!instanceUrl) {
    return {
      // Still passed along so the failed instance resolution can be reported to analytics.
      streamUuid,
      error: {
        title: 'Instance not authorized',
        message: 'This Webble-Cast instance is not authorized to use this player.',
      },
    };
  }

  const params = new URLSearchParams(search);
  const rawType = (params.get('stream_id_type') || 'internal').toLowerCase();
  const streamIdType = rawType === 'external' ? 'external' : 'internal';

  return { instanceUrl, streamUuid, streamIdType };
}
